<template>
  <div class="main">
    <CartHeader />
    <CartTable />
    <!-- Terms and Conditions-->
    <div class="row justify-content-center" v-if="getProductsSize() >= 1">
      <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
        <div class="form-group">
          <label for="tnc">
            <input
              type="checkbox"
              id="TnC"
              v-model="bind_TermsnConditions"
              v-on:change="maintainLocalStorageTerms()"
            />
            <span>
              &nbsp;Please confirm you accept our
              <a
                style="color: #6dbe45"
                href="https://westerncontainersales.com/about-shipping-containers/terms-conditions/"
                target="_blank"
                >&nbsp; terms & conditions &nbsp;</a
              >
              prior to placing your order.
            </span>
          </label>
        </div>
      </div>
    </div>

    <div class="checkout">
      <!-- checkout button -->
      <v-btn
        color="#ffffff"
        class="btns place_order_btn"
        style="color: #00587d; width: 220px"
        medium
        v-if="getProductsSize() >= 1"
        :disabled="!terms_conditions"
        @click="navigatePredelivery()"
        :class="{ 'disabled-btn': !terms_conditions }"
        >Proceed with Order<v-icon> mdi-arrow-right-thick </v-icon></v-btn
      >
      <!-- get quote button -->
      <v-btn
        @click="navigateQuoteSections()"
        color="#00587d"
        class="btns quote_btn"
        style="color: #ffffff"
        medium
        v-if="getProductsSize() >= 1"
        :disabled="!terms_conditions"
        >Email Quote<v-icon> mdi-email-check </v-icon></v-btn
      >
      <!-- get RTO quote button -->
      <v-btn
        @click="navigateRTOQuoteSection()"
        color="#6dbe45"
        class="btns renttoown_btn"
        style="color: #ffffff"
        medium
        v-if="checkRTOButton()"
        :disabled="!terms_conditions"
        >Rent to Own<v-icon> mdi-credit-card-edit </v-icon></v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import * as types from "@/store/types";
import CartHeader from "./pages/CartHeader.vue";
import CartTable from "./pages/CartTable.vue";

Vue.use(VueNumberInput);

export default {
  name: "ShoppingCart",
  components: {
    CartHeader,
    CartTable,
  },
  computed: {
    ...mapGetters({
      CART: types.CART_LIST,
      terms_conditions: types.TERMSCHECKBOX,
      COUNTRY_CODE: types.COUNTRYCODE,
    }),
    bind_TermsnConditions: {
      get() {
        return this.terms_conditions;
      },
      set(value) {
        this.updateTermsConditions(value);
      },
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.intializeOrderType();
  },
  data() {
    return {
      orderDeliveryType: false,
      orderPickupType: false,
    };
  },
  methods: {
    ...mapActions({
      updateTermsConditions: types.ACTIONS_UPDATE_TERMSCHECKBOX,
    }),
    intializeOrderType() {
      if (this.CART.length === 0) {
        this.orderDeliveryType = false;
        this.orderPickupType = false;
        return;
      }

      //only display questions specific to the order type
      var deliveryType = false,
        pickupType = false;
      setTimeout(() => {
        if (
          this.CART[0]["customAttributes"]["Delivery"].toUpperCase() ===
          "DELIVERY"
        )
          deliveryType = true;
        else if (
          this.CART[0]["customAttributes"]["Delivery"].toUpperCase() ===
          "PICK-UP"
        )
          pickupType = true;

        this.orderDeliveryType = deliveryType;
        this.orderPickupType = pickupType;
      }, 100);
    },
    getProductsSize() {
      return this.CART.length;
    },
    navigateQuoteSections() {
      this.$router.push("/quote");
    },
    navigateRTOQuoteSection() {
      this.$router.push("/rto_quote");
    },
    navigatePredelivery() {
      if (this.orderDeliveryType) this.$router.push("/predeliveryform");
      else this.$router.push("/prepickupform");
    },
    /* Hide RTO Button
     1. Empty Cart 2. Pickup 3. Country is not US 4. Export container present
    */
    checkRTOButton() {
      if (
        !this.getProductsSize() ||
        !this.orderDeliveryType ||
        this.COUNTRY_CODE != "US"
      )
        return false;

      const IDX = this.CART.findIndex(
        (p) => p.customAttributes.Purpose == "EXPORT"
      );
      if (IDX >= 0) return false;

      return true;
    },
    maintainLocalStorageTerms() {
      const termsCheckbox = JSON.stringify(this.terms_conditions);
      localStorage.setItem("termsCheckbox", termsCheckbox);
    },
  },
  watch: {
    CART: function () {
      this.intializeOrderType();
    },
  },
};
</script>

<style scoped>
.btns {
  text-decoration: none;
  font-weight: 700;
  text-transform: unset !important;
  border-radius: 15px;
  margin: 15px;
}

.btns i {
  max-width: 0;
  transition: max-width 0.5s;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  margin-left: 10px;
}

.btns:hover i {
  max-width: 15rem;
  transition-delay: 0.1s;
}
.quote_btn {
  box-shadow: 1px 1px 1px 1px #6dbe45;
}

.renttoown_btn {
  box-shadow: 1px 1px 1px 1px #ffffff;
}

.place_order_btn {
  box-shadow: 1px 1px 1px 1px #6dbe45;
}

.main {
  margin: 0px auto;
  padding: 10px;
  width: 90%;
  text-align: center;
  color: white;
}

.checkout button[class*="btn"] {
  display: inline-block;
  cursor: pointer;
  width: 180px;
  height: 40px;
  margin-bottom: 40px;
}

a {
  font-size: 20px;
}

input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

@media only screen and (max-width: 880px) {
  div,
  a,
  v-btn,
  input {
    font-size: 20px;
  }
}

@media only screen and (min-width: 880px) and (max-width: 1100px) {
  div,
  a,
  v-btn,
  input {
    font-size: 11px;
  }
}

@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  div,
  a,
  v-btn,
  input {
    font-size: 18px;
  }
}

@media only screen and (min-width: 1400px) {
  div,
  a,
  v-btn,
  input {
    font-size: 24px;
  }
}

@media screen and (max-width: 480px) {
  .main {
    width: 100%;
  }
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  opacity: 0.6 !important;
  background-color: #ffffff !important;
}
</style>
